import Cookies from 'universal-cookie';
import { routes } from './routes';

export const registrationSteps = {
    registratingPhoneNumber: 1,
    verifyPhoneNumber: 2,
    fillingProfile: 3,
    settingPreferences: 4,
    completed: 5
};

export const defaultRegistrationStep = registrationSteps.registratingPhoneNumber;